import { useTranslate } from '@tolgee/react';
import { useMemoizedFn } from 'ahooks';
import { message } from 'antd';
import { useSetConversationIdListValue } from 'hooks/business/conversation';
import { useOpenConversation } from 'hooks/business/conversationsHooks/useOpenConversation';
import { uniq } from 'lodash-es';
import { searchType } from 'services/api/conversation.convList';
import { toUpperCase } from 'utils/toLowerCase';
import { useFetchCreateConversation } from 'views/Conversation/ConvList/SearchPageItem';

interface OpenChatFromOrderParams {
  orderId: string;
  storeId: string;
  region: string;
  tunnelType: string;
}

export const useOpenChatFromOrder = () => {
  const fetchCreateConversation = useFetchCreateConversation();
  const openConversation = useOpenConversation();
  const setConversationIdList = useSetConversationIdListValue();
  const { t } = useTranslate();

  return useMemoizedFn(async (params: OpenChatFromOrderParams) => {
    const { orderId, storeId, region, tunnelType } = params;

    try {
      const searchResult = await searchType({
        type: 'order',
        pageSize: 1,
        offset: '0',
        keyword: orderId,
        externalStoreId: storeId,
        region: toUpperCase(region) as General.UpperCaseRegion,
        tunnelType: toUpperCase(tunnelType) as General.PlatformUpperCaseTunnel,
      });
      const searchData = searchResult?.searchRow?.[0];
      if (searchData) {
        const { region, platform, externalStoreId, externalBuyerId, buyerNick } = searchData;
        // 后端搜索 创建静默单
        const conversation = await fetchCreateConversation(
          {
            region,
            channel: platform,
            externalStoreId,
            externalBuyerId,
            buyerNick,
            orderId,
          },
          '',
        );
        const conversationId = conversation.conversationId;
        openConversation(conversation, { category: 'mine', orderSn: orderId });
        setConversationIdList((pre) => uniq([...pre, conversationId]));
      } else {
        message.error(t('msg_chat_from_msg_not_found', { orderId }));
      }
    } catch (err) {
      message.error(t('phrase.获取数据失败，请稍后再试'));
    }
  });
};
